export default __webpack_public_path__ + "static/media/torso-top-right-side.74909ef6.png";